import { createAction, props } from '@ngrx/store';
import { Activity, ClubUser } from './club-user.model';

// fetch 
export const fetchClubUserListData = createAction('[Data] fetch club user list');
export const fetchClubUserListSuccess = createAction('[Data] fetch club user list success', props<{ ClubUserListdata: ClubUser[] }>())
export const fetchClubUserListFail = createAction('[Data fetch club user list failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records club user',
    props<{ clubId: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records club user success', 
    props<{ listData: ClubUser[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records club user failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record club user',
    props<{clubId:string, id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record club user success', 
    props<{ singleData: ClubUser }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record club user failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add record club User',
    props<{ clubId: string, newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record club User success'
);
export const addRecordFailure = createAction(
    '[Data] Add record club User failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record club user',
    props<{ clubId: string, id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record club user success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record club user failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record club user',
    props<{ clubId:string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record club user success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record club user failure',
    props<{ error: string }>()
);

//Reset Invitation
export const resendInvitation = createAction(
    '[Data] Resend club user invitation',
    props<{ id: string }>()
);
export const resendInvitationSuccess = createAction(
    '[Data] Resend club user invitation success'
);
export const resendInvitationFailure = createAction(
    '[Data] Resend club user invitation failure',
    props<{ error: string }>()
);


//Reset Two Factor
export const resetTwoFactor = createAction(
    '[Data] Reset Two Factor',
    props<{ id: string }>()
);
export const resetTwoFactorSuccess = createAction(
    '[Data] Reset Two Factor success'
);
export const resetTwoFactorFailure = createAction(
    '[Data] Reset Two Factor failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state club user',
);
